// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"d888df10","376":"926bf0aa","422":"66db8360","471":"e10cef4c","571":"0a1b756a","636":"90fcd400","640":"1fd51931"}[chunkId] + ".chunk.js";
};